import React from 'react';
import { Avatar, Box, Typography, useTheme } from '@ublend-npm/aulaui-core';
import { createStyles } from './PostCard.styles';

export const PostTagsPlaceholder = () => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box aria-label="Tags placeholder" sx={styles.tagPlaceholder}>
      <Typography aria-hidden="true" sx={styles.tagIcon}>
        #
      </Typography>
      <Box sx={styles.tagPill}>Tags</Box>
    </Box>
  );
};

export const PostReactionsPlaceholder = () => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box aria-label="Reactions placeholder" sx={styles.reactionPlaceholder}>
      <Typography aria-hidden="true" sx={styles.reactionIcon}>
        ☺+
      </Typography>
      <Typography sx={styles.reactionLabel}>Reactions</Typography>
    </Box>
  );
};

export const PostCommentsPlaceholder = () => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box
      aria-label="Comment and reply placeholder"
      sx={styles.commentsPlaceholder}
    >
      <Avatar
        altText="Current user"
        fallbackText="OP"
        kind="circular"
        sx={styles.commentsAvatar}
      />
      <Box sx={styles.commentsField}>Placeholder for Aula Editor</Box>
    </Box>
  );
};
